import { apiClient, extractApiError } from './api';
import { Notification, ApiResponse } from '@/types';

class NotificationService {
  /**
   * Get all notifications
   */
  async getNotifications(params?: { page?: number; limit?: number; isRead?: boolean }): Promise<{ notifications: Notification[], total: number }> {
    try {
      const response = await apiClient.get<ApiResponse<{ notifications: Notification[], total: number }>>('/notifications', { params });
      return response.data.data || { notifications: [], total: 0 };
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Get unread count
   */
  async getUnreadCount(): Promise<number> {
    try {
      const response = await apiClient.get<ApiResponse<{ count: number }>>('/notifications/unread-count');
      return response.data.data?.count || 0;
    } catch {
       return 0;
    }
  }

  /**
   * Mark notification as read
   */
  async markAsRead(id: string): Promise<void> {
    try {
      await apiClient.put(`/notifications/${id}/read`);
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Mark all as read
   */
  async markAllAsRead(): Promise<void> {
    try {
      await apiClient.put('/notifications/read-all');
    } catch (error) {
      throw extractApiError(error);
    }
  }
}

export const notificationService = new NotificationService();
export default notificationService;
